import React, { useEffect, useState } from "react";
import { useAuth } from "context/auth-context";
import { toastrError, toastrSuccess } from "./../../lib/toastr";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAccountDetails } from "./Account.api";
import { uploadProfileImage } from "./Account.api";
import { useSubscribe } from "context/Subscribe-context";
import { subscribeUser, subscribeStatus } from "./Subscribe.api";
import { useTranslation } from "react-i18next";
import LogoutConfirmation from "pages/Logout/LogoutConfirmationModel";
import { PageHeader, SkeletonRows } from "components/ui";
import { AccountProfileHeader } from "./AccountProfileHeader";
import { AccountPersonalDetails } from "./AccountPersonalDetails";
import { AccountSecurity } from "./AccountSecurity";
import { AccountManageSections } from "./AccountManageSections";
import BackupCodesModal from "components/mfaSetup/BackupCodesModal";
import MfaSetupPage from "components/mfaSetup/MfaSetupPage";
import { useMfaStatus } from "components/mfaSetup/useMfa";
import DisableMfaModal from "components/mfaSetup/DisableMfaModal";
import AccountActionsModal from "./AccountActionsModal";

export const Account = () => {
  const { t } = useTranslation();
  const intialState = {
    name: "",
    Gender: "",
    email: "",
  };
  const [formValue, setFormValue] = useState(intialState);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);
  const [isPopupOpenDob, setIsPopupOpenDob] = useState(false);
  const [isPopupOpenGender, setIsPopupOpenGender] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [mfaModalOpen, setMfaModalOpen] = useState(false);
  // const [backupCodes, setBackupCodes] = useState([]);
  const [showBackupModal, setShowBackupModal] = useState(false);
  const [showDisableMfaModal, setShowDisableMfaModal] = useState(false);
  const [showAccountActions, setShowAccountActions] = useState(false);

  const { auth } = useAuth();
  const { setAuth } = useAuth();

  const queryClient = useQueryClient();

  const { data } = useMfaStatus();

  useEffect(() => {
    if (data?.data?.data?.mfa_enabled) {
      setMfaEnabled(true);
    }
  }, [data]);

  const uploadImage = async (imageFile) => {
    try {
      setIsUploading(true);
      if (!imageFile) {
        setIsUploading(false);
        return;
      }
      const panelistId = auth.panelistId;

      await uploadProfileImage(panelistId, imageFile);

      queryClient.invalidateQueries(["getAccountDetailsapi"]);
      toastrSuccess("Profile image uploaded successfully");
    } catch (error) {
      toastrError("Failed to upload profile image");
    } finally {
      setIsUploading(false);
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "image/jpeg" || file.type === "image/png") {
        uploadImage(file);
      } else {
        toastrError("Please select an image file (JPEG, PNG)");
      }
    }
  };

  const togglepopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };
  const togglepopup1 = () => {
    setIsPopupOpen1(!isPopupOpen1);
  };

  const toggleDobpopup = () => {
    setIsPopupOpenDob(!isPopupOpenDob);
  };

  const toggleGenderpopup = () => {
    setIsPopupOpenGender(!isPopupOpenDob);
  };

  const dates: string[] = [];
  const title: string[] = [];

  const getuserData = useQuery(
    ["getAccountDetailsapi", formValue],
    () => getAccountDetails(auth.panelistId),
    {
      onSuccess: (response: any) => {
        if (response?.success) {
          setAuth({
            ...auth,
            profile_pic: response?.result[0]?.profile_pic,
            name: response?.result[0]?.user_nicename,
          });

          queryClient.invalidateQueries(["getAccountDetails"]);
        } else {
          toastrError(response.message);
        }
      },
      onError: () => {
        toastrError("please write good email");
      },
    }
  );
  //  for joinDate
  getuserData?.data?.result?.map((item) => {
    const dat = item.user_registered;
    const dateString = dat;
    const date = new Date(dateString);

    const formatter = new Intl.DateTimeFormat("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const formattedDate = formatter.format(date);
    dates.push(formattedDate);
    title.push(item.user_nicename);
  });
  const username = title[0];
  if (getuserData && getuserData.data && Array.isArray(getuserData.data.result)) {
    // const userLogin = getuserData;
  }

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };
  const handleKeyDown = (e) => {
    e.preventDefault();
  };

  const { isSubscribe, setisSubscribe } = useSubscribe();
  useEffect(() => {
    const fetchInitialSubscriptionStatus = async () => {
      try {
        const response = await subscribeStatus(auth.panelistId);
        setisSubscribe(response.result);
      } catch (error) {
        setisSubscribe(0);
      }
    };
    fetchInitialSubscriptionStatus();
  }, [auth.panelistId, setisSubscribe]);

  const mutation = useMutation(() => subscribeUser(auth.panelistId), {
    onSuccess(data) {
      if (data.result === 1) {
        setisSubscribe(data.result);
        toastrSuccess(data.message);
      }
    },
    onError() {
      toastrError(t("account.error.subscribe"));
    },
  });

  const handleSubscribe = (e) => {
    e.preventDefault();
    mutation.mutate();
  };

  const handleMFAToggle = async (e) => {
    e.preventDefault();

    if (mfaEnabled) {
      setShowDisableMfaModal(true);
    } else {
      setMfaModalOpen(true);
    }
  };

  return (
    <>
      <div className="zs-page zs-page-medium">
        <PageHeader
          eyebrow="Settings"
          title={t("side.bar.Account")}
          subtitle="Manage your profile, security and email preferences."
        />

        {getuserData.isLoading && (
          <div className="flex flex-col gap-6" aria-busy="true">
            <span className="sr-only">{t("claim.card.Loading")}</span>
            <div className="flex items-center gap-5 p-6 zs-card">
              <div className="w-20 h-20 rounded-full zs-skeleton sm:w-24 sm:h-24" />
              <div className="flex flex-col flex-1 gap-2">
                <div className="w-40 h-5 zs-skeleton" />
                <div className="w-56 h-4 zs-skeleton" />
              </div>
            </div>
            <div className="zs-card">
              <SkeletonRows rows={4} />
            </div>
          </div>
        )}

        {getuserData &&
          getuserData.data &&
          Array.isArray(getuserData.data.result) &&
          getuserData.data.result.length > 0 &&
          getuserData.data.result.map((item, i) => (
            <div key={i} className="flex flex-col gap-6">
              <AccountProfileHeader
                item={item}
                isUploading={isUploading}
                setIsUploading={setIsUploading}
                onFileSelect={handleFileSelect}
                onKeyDown={handleKeyDown}
                joinedLabel={t("Account.user_status")}
                joinedDate={dates[0]}
                mfaEnabled={mfaEnabled}
              />
              <form className="flex flex-col gap-6">
                <AccountPersonalDetails
                  item={item}
                  username={username}
                  onInputChange={onInputChange}
                  handleKeyDown={handleKeyDown}
                  isPopupOpenGender={isPopupOpenGender}
                  setIsPopupOpenGender={setIsPopupOpenGender}
                  toggleGenderpopup={toggleGenderpopup}
                  isPopupOpenDob={isPopupOpenDob}
                  setIsPopupOpenDob={setIsPopupOpenDob}
                  toggleDobpopup={toggleDobpopup}
                  isPopupOpen={isPopupOpen}
                  setIsPopupOpen={setIsPopupOpen}
                  togglepopup={togglepopup}
                />
                <AccountSecurity
                  handleKeyDown={handleKeyDown}
                  isPopupOpen1={isPopupOpen1}
                  setIsPopupOpen1={setIsPopupOpen1}
                  togglepopup1={togglepopup1}
                  mfaEnabled={mfaEnabled}
                  onShowBackupCodes={() => setShowBackupModal(true)}
                  handleMFAToggle={handleMFAToggle}
                />
              </form>
              <AccountManageSections
                isSubscribe={isSubscribe}
                handleSubscribe={handleSubscribe}
                onLogout={() => setShowLogoutPopup(true)}
                onShowAccountActions={() => setShowAccountActions(true)}
              />
            </div>
          ))}
      </div>
      {showLogoutPopup && <LogoutConfirmation onClose={() => setShowLogoutPopup(false)} />}
      {mfaModalOpen && <MfaSetupPage onClose={() => setMfaModalOpen(false)} />}
      {showBackupModal && <BackupCodesModal onClose={() => setShowBackupModal(false)} />}
      {showAccountActions && <AccountActionsModal onClose={() => setShowAccountActions(false)} />}
      {/* Disable MFA Confirmation Modal */}
      {showDisableMfaModal && (
        <DisableMfaModal
          onClose={() => setShowDisableMfaModal(false)}
          onSuccess={() => {
            setMfaEnabled(false);
            queryClient.invalidateQueries(["mfa-status"]);
          }}
        />
      )}
    </>
  );
};
